RivalIQ.apps.Insights.module('curations', function (curations, App, Backbone, Marionette, $, _) {

    'use strict';

    const config = [
        {
            name: 'top',
            sizes: {
                md: 12
            },
            page: 0
        },
        {
            name: 'stories',
            sizes: {
                md: 12
            },
            page: 1
        },
        [
            {
                name: 'reach',
                sizes: {
                    md: 6,
                    sm: 12,
                    'sm-export': 6
                },
                page: 2
            },
            {
                name: 'completion-rate',
                sizes: {
                    md: 6,
                    sm: 12,
                    'sm-export': 6
                },
                page: 2
            }
        ],
        {
            name: 'hashtags',
            sizes: {
                md: 12
            },
            page: 3
        },
        {
            name: 'by-type',
            sizes: {
                md: 12
            },
            page: 4
        },
        {
            name: 'time-usage',
            sizes: {
                md: 12
            },
            page: 5
        }
    ];

    curations.InstagramInsightsStoriesCuration = curations._BaseInstagramInsightsCuration.extend({

        widgetsView: App.views.InstagramInsightsLayout.extend({
            config: config
        }),
        widgetView: App.views.InsightsDetailsLayout,

        exportTitle: 'Instagram Insights Stories',

        loadConfiguration: function () {
            const me = this;
            return RivalIQ.data.configuration.fetch(me, me.getProps());
        },

        processProps: function (props) {
            const me = this;

            // We don't allow filtering by type unless you're in the details view of the table looking
            // at stories.
            if (me.isFocus() || props.objectType !== 'story') {
                props.mediaTypeFilter = undefined;
            }

            return props;
        }
    });
});
